module.exports = __webpack_public_path__ + "img/pc-plus.d633a0ee.svg";